import OrderDTO from "@/dto/order/OrderDTO";
import { addMarkToOrder } from "@/services/api/order";
import { useRequest } from "ahooks";

export default function useAddMarkRequest() {
    return useRequest(
        async (order: OrderDTO, markId: number) => {
            const orderIds = [order.id];

            if (order.childOrders?.length) {
                orderIds.push(...order.childOrders.map((order) => order.id));
            }

            return addMarkToOrder({
                shopId: order.shopId,
                orderIds,
                markId,
            });
        },
        {
            manual: true,
        },
    );
}
